import { render, staticRenderFns } from "./WidgetVk.vue?vue&type=template&id=7b7b57b7&"
import script from "./WidgetVk.vue?vue&type=script&lang=js&"
export * from "./WidgetVk.vue?vue&type=script&lang=js&"
import style0 from "./WidgetVk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports